import { useState } from "react";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Typography, WhiteBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import SupersetChartEmbed from "src/components/Superset/SupersetChartEmbed.tsx";

export type SupersetChartBlockProps = {
    title?: string;
    src: string;
    height?: number;
    hideWhenEmpty?: boolean;
    isEditing?: boolean;
};

export const SupersetChartBlock = (props: SupersetChartBlockProps) => {
    const { title, src, height, hideWhenEmpty = false, isEditing = false } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const [emptySrc, setEmptySrc] = useState<string | null>(null);

    const shouldHideWhenEmpty = hideWhenEmpty && !isEditing;

    if (shouldHideWhenEmpty && emptySrc === src) {
        return null;
    }

    /*
     * Magic number of background color (#f7f7f7) exceptionally done here,
     * because we don't have the hand of superset default styling for the moment
     */
    return (
        <Stack sx={{ gap: theme.spacing(1) }}>
            {title && <Typography variant="h4">{title}</Typography>}
            {isEditing && hideWhenEmpty && (
                <Typography variant="body2">
                    {t(
                        "puck.blocks.superset_chart.hidden_when_empty",
                        "Hidden on the published page when the chart has no data",
                    )}
                </Typography>
            )}
            <WhiteBox
                sx={{
                    backgroundColor: "#f7f7f7",
                }}
            >
                <SupersetChartEmbed
                    src={src}
                    height={height}
                    hideWhenEmpty={shouldHideWhenEmpty}
                    onEmptyChange={(isEmpty) => setEmptySrc(isEmpty ? src : null)}
                />
            </WhiteBox>
        </Stack>
    );
};

export default SupersetChartBlock;
